import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';

var fetchFunctions = {};
fetchFunctions.getGlobalSiteHeaderConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function (_ref2) {
    var osAccessToken = _ref2.osAccessToken,
      aosUrl = _ref2.aosUrl,
      locale = _ref2.locale,
      appName = _ref2.appName;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var requestOptions, response, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            requestOptions = {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: osAccessToken,
                'x-account-locale': locale,
                app: appName
              },
              method: 'GET',
              credentials: 'omit'
            };
            _context.prev = 1;
            _context.next = 4;
            return fetch("".concat(aosUrl, "/api/configs/globalSiteHeaderConfig"), requestOptions);
          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();
          case 7:
            result = _context.sent;
            if (!(response.status === 200)) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", result.data);
          case 10:
            return _context.abrupt("return", {});
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", {});
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 13]]);
    })();
  });
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

export { fetchFunctions as default };
